
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '../../../styles/helpers/StyleClassNamesBuilder';
import { DisplayState } from '../enums';

const DISABLE_SCROLL_CLASS = 'stop-scroll';

export default {
  name: 'ModalOverlay',
  props: {
    clickHandler: {
      type: Function,
      default: null,
    },
    show: {
      type: Boolean,
      required: true,
    },
    colorScheme: {
      type: String,
      default: StyleColorSchemeType.Black,
    },
  },
  computed: {
    showState() {
      return this.show ? DisplayState.Opened : DisplayState.Closed;
    },
    overlayClassNames() {
      return new StyleClassNamesBuilder('modal-overlay')
        .addConditionClassNames(Object.values(DisplayState), this.showState)
        .addConditionClassNames(Object.values(StyleColorSchemeType), this.colorScheme)
        .build();
    },
  },
  mounted() {
    document.documentElement.classList.add(DISABLE_SCROLL_CLASS);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(DISABLE_SCROLL_CLASS);
  },
  methods: {
    handleOverlayClick() {
      if (this.clickHandler) {
        this.clickHandler();
      }
    },
  },
};
